import React from 'react';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle } from '@fortawesome/pro-duotone-svg-icons';

const GuideButton = ({ className, open }) => (
  <Button color="white" className={className} onClick={open}>
    <FontAwesomeIcon icon={faQuestionCircle} size="lg" />
  </Button>
);

const mapDispatchToProps = (dispatch, { id }) => ({
  open: () => dispatch({ type: 'OPEN_GUIDE', id }),
});

export default connect(null, mapDispatchToProps)(GuideButton);
